import { render } from "./LabCoverSheet.vue?vue&type=template&id=52d7b7e4"
import script from "./LabCoverSheet.vue?vue&type=script&lang=js"
export * from "./LabCoverSheet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__